import { render, staticRenderFns } from "./juniorCollege.vue?vue&type=template&id=adbfb970&"
import script from "./juniorCollege.vue?vue&type=script&lang=js&"
export * from "./juniorCollege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports